
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import Vue from 'vue';
import { RuleAction, RuleActionDefinition } from '@/types';
import RuleCustomValueDisplay from './RuleCustomValueDisplay.vue';
import RuleItemPickerDialog from './RuleItemPickerDialog.vue';

@Component({
  components: {
    RuleCustomValueDisplay,
    RuleItemPickerDialog,
  },
})
export default class RuleActionBuilder extends Vue {
  @Prop({ type: Array, required: true }) readonly value!: RuleAction[];
  @Prop({ type: Array, required: true }) readonly actionDefinitions!: RuleActionDefinition[];
  @Prop({ type: Array, default: () => [] }) readonly users!: any[];
  @Prop({ type: Array, default: () => [] }) readonly groups!: any[];
  @Prop({ type: Array, default: () => [] }) readonly categories!: any[];
  @Prop({ type: Array, default: () => [] }) readonly tags!: any[];
  @Prop({ type: Array, default: () => [] }) readonly templates!: any[];
  @Prop({ type: Array, default: () => [] }) readonly checklists!: any[];

  dialogOpen = false;
  editingItem: RuleAction | null = null;
  editingIndex = -1;
  actionCounter = 0;

  @Watch('value', { immediate: true })
  onValueChanged(actions: RuleAction[]): void {
    if (actions && actions.length > 0) {
      const maxOrder = Math.max(...actions.map((a) => a.order || 0));
      this.actionCounter = maxOrder + 1;
    }
  }

  openAddDialog(): void {
    this.editingItem = null;
    this.editingIndex = -1;
    this.dialogOpen = true;
  }

  openEditDialog(index: number): void {
    this.editingItem = this.value[index];
    this.editingIndex = index;
    this.dialogOpen = true;
  }

  onItemAdded(item: RuleAction): void {
    const action = { ...item, order: this.actionCounter };
    this.actionCounter += 1;

    // Apply default sender if applicable
    this.applyDefaultSender(action);

    this.$emit('input', [...this.value, action]);
  }

  onItemUpdated(item: RuleAction): void {
    if (this.editingIndex < 0) return;
    const action = { ...item, order: this.value[this.editingIndex].order };
    const newActions = [...this.value];
    newActions[this.editingIndex] = action;
    this.$emit('input', newActions);
  }

  removeAction(index: number): void {
    if (!window.confirm('Eliminare questa azione?')) return;
    const newActions = [...this.value];
    newActions.splice(index, 1);
    this.$emit('input', newActions);
  }

  private applyDefaultSender(action: RuleAction): void {
    const senderCv = action.customValues.find((cv) => cv.name === 'sender');
    if (senderCv && !senderCv.value) {
      senderCv.value = '"Portale Partner Syndesia" <info@syndesia.eu>';
    }
  }
}
